import TailwindFlex from 'library/components/_tailwind/flex';
import TailwindText from 'library/components/_tailwind/text';
import TailwindTranslatedText from 'library/components/_tailwind/translated-text';
import React from 'react';
import { observer } from 'mobx-react';

type Props = {};

const MissingPgProfilePhotoError: React.ComponentType<Props> = ({}) => {

  return (
    <TailwindFlex
      height={"h-full"}
      width={"w-full"}
      flexDirection={"flex-col"}
      alignItems={"items-center"}
      justifyContent={'justify-center'}
    >
      <TailwindFlex
        width={"w-full"}
        maxWidth={'max-w-3xl'}
        flexDirection={'flex-col'}
        alignItems={"items-center"}
        justifyContent={'justify-center'}
      >
        <TailwindTranslatedText
            fontSize={"text-xl"}
            margin={["mb-2"]}
            fontWeight={"font-bold"}
            textAlign={"text-center"}
            descriptor={{
              id: "missing-pg-profile-photo-error.access-denied",
              defaultMessage: "Access Denied",
            }}
        />
        <TailwindText
          margin={["mb-8"]}
          textAlign={"text-center"}
          textColor={"text-red-500"}
        >
          <TailwindTranslatedText
            descriptor={{
              id: "missing-pg-profile-photo-error.body",
              defaultMessage:
                "You do not currently have an approved PG profile photo. In the Model Center, please go to My Page -> My Listing Photo and upload a photo to your Promotional Image Album. It must be in landscape orientation, measure between 200px and 100px on the longest side, and contain no nudity. If you have any questions, please contact our live support for assistance.",
            }}
          />
        </TailwindText>
        <TailwindTranslatedText
          margin={["mb-4"]}
          textAlign={"text-center"}
          descriptor={{
            id: "missing-pg-profile-photo-error.further-assistance",
            defaultMessage:
              "For further assistance, please contact the compliance department (408)702-1048 or email.",
          }}
        />
        <TailwindTranslatedText
          margin={["mb-8"]}
          textAlign={"text-center"}
          fontWeight={"font-bold"}
          descriptor={{
            id: "missing-pg-profile-photo-error.the-cams-staff",
            defaultMessage: "The Cams Staff",
          }}
        />
      </TailwindFlex>
    </TailwindFlex>
  );
}

export default observer(MissingPgProfilePhotoError);
